import React from "react";
import ArrowDownIcon from "../../Icons/ArrowDownIcon";
import SkyeDropdown, { DropdownWrapper } from "./Dropdown";
import DropdownItem from "./DropdownItem";
import classNames from "classnames";

export interface ISelectOption {
  icon?: any;
  title: string;
  description?: string;
  value: any;
}

interface ISelectDropdownProptypes {
  options: ISelectOption[];
  currentSelectedLabel: any;
  placeholder: any;
  onSelect: (value: any) => void;
}

const handleSelect = (currentValue: any, callback: any) => () => {
  callback(currentValue);
};

const SelectDropdown = ({
  options,
  currentSelectedLabel,
  placeholder,
  onSelect,
}: ISelectDropdownProptypes) => {
  return (
    <SkyeDropdown
      onChange={() => {}}
      overlay={
        <DropdownWrapper>
          <div className="options-container bg-surface-primary rounded-lg flex flex-col gap-2">
            {options.map((option) => (
              <DropdownItem
                key={option.value}
                onClick={handleSelect(option.value, onSelect)}
                className="px-5 py-2 h-auto"
              >
                {!!option.icon && (
                  <div className="icon-wrapperw-[44px] h-[44px] mr-5 flex items-center justify-center">
                    {option.icon}
                  </div>
                )}
                <div>
                  <div className="text-sm font-medium">{option.title}</div>
                  {!!option.description && (
                    <div className="text-xs text-text-placeholder">
                      {option.description}
                    </div>
                  )}
                </div>
              </DropdownItem>
            ))}
          </div>
        </DropdownWrapper>
      }
    >
      <div className="select-container flex items-center justify-between h-[42px] border border-primary rounded-lg px-5 bg-background-card cursor-pointer">
        <div
          className={classNames([
            "select-value text-sm font-normal",
            {
              "text-text-primary": currentSelectedLabel,
              "text-text-placeholder": !currentSelectedLabel,
            },
          ])}
        >
          {currentSelectedLabel || placeholder}
        </div>
        <div className="arrow-icon-wrapper h-5 w-5 flex items-center justify-center">
          <ArrowDownIcon />
        </div>
      </div>
    </SkyeDropdown>
  );
};

export default SelectDropdown;
